import { UilCube } from '@iconscout/react-unicons';
import { PERMISSIONS } from 'constants/permissions';
import { RouteItems } from 'routes/types/types';

export const routes: RouteItems[] = [
  {
    label: 'ops',
    icon: UilCube,
    pages: [
      {
        name: 'Dashboard',
        active: true,
        icon: 'grid',
        path: '/home/apps/job/project-card-view',
        pathName: 'view-job',
        pages: [
          {
            name: 'Active Jobs',
            path: '/home/apps/job/project-card-view',
            pathName: 'view-job',
            icon: 'briefcase',
            active: true
          },
          {
            name: 'Archived Jobs',
            path: '/home/apps/job/archive',
            pathName: 'view-job',
            icon: 'archive',
            active: true
          }
        ]
      },
      {
        name: 'Resources',
        active: true,
        icon: 'book',
        path: '/home/apps/resources',
        pathName: 'View All Resources',
        pages: [
          {
            name: 'Pressure Drop',
            path: '/home/apps/pressure-drop',
            pathName: 'Pressure Drop Calculator',
            active: true,
            icon: 'droplet',
            flat: true,
            permission: PERMISSIONS.RESOURCES.READ
          },
          {
            name: 'Call-Out Cal',
            path: '/home/apps/call-out',
            pathName: 'Call-Out Calendar',
            active: true,
            icon: 'calendar',
            flat: true,
            permission: PERMISSIONS.CALL_OUT_CALENDAR.READ
          },
          {
            name: 'HO Opti-Calc',
            path: '/home/apps/ho-optimization-calculator',
            pathName: 'HO Optimization Calculator',
            active: true,
            icon: 'hash',
            flat: true,
            permission: PERMISSIONS.RESOURCES.READ
          },
          {
            name: 'Shop Daily Maintenance',
            path: '/home/apps/shop-daily-maintenance/overhead-crane',
            pathName: 'Shop Daily Maintenance',
            active: true,
            icon: 'folder',
            permission: PERMISSIONS.INSPECTION_FORMS.OVERHEAD_CRANE.READ,
            pages: [
              {
                name: 'Overhead Crane',
                path: '/home/apps/shop-daily-maintenance/overhead-crane',
                pathName: 'Overhead Crane Form',
                active: true,
                icon: 'file-text',
                flat: true
              },
              {
                name: 'HOC Obs. Card',
                path: '/home/apps/shop-daily-maintenance/observation-card',
                pathName: 'HOC Observation Card',
                active: true,
                icon: 'file-text',
                flat: true
              },
              {
                name: 'Waste Water',
                path: '/home/apps/shop-daily-maintenance/waste-water',
                pathName: 'Waste Water Inspection',
                active: true,
                icon: 'file-text',
                flat: true
              },
              {
                name: 'Forklift',
                path: '/home/apps/shop-daily-maintenance/forklift',
                pathName: 'Forklift Inspection',
                active: true,
                icon: 'file-text',
                flat: true
              }
            ]
          }
        ]
      },
      {
        name: 'Activities',
        active: true,
        icon: 'activity',
        path: '/home/apps/activities',
        pathName: 'View All Activities',
        permission: PERMISSIONS.CUSTOMER.REPRESENTATIVE.READ,
        pages: [
          {
            name: 'Tasks',
            path: '/home/apps/tasks',
            pathName: 'View All Tasks',
            active: true,
            icon: 'check-square',
            permission: PERMISSIONS.CUSTOMER.REPRESENTATIVE.READ
          },
          {
            name: 'Notifications',
            path: '/notifications',
            pathName: 'Notifications',
            active: true,
            icon: 'bell',
            permission: PERMISSIONS.CUSTOMER.REPRESENTATIVE.READ
          },
          {
            name: 'App Feedback',
            path: '/home/apps/admin-feedback',
            pathName: 'View App Feedback',
            active: true,
            icon: 'message-square',
            adminOnly: true
          }
        ]
      },
      {
        name: 'Customer',
        active: true,
        icon: 'home',
        path: '/home/apps/company',
        pathName: 'View All Company',
        permission: PERMISSIONS.CUSTOMER.COMPANY.READ,
        pages: [
          {
            name: 'Company',
            path: '/home/apps/company',
            pathName: 'View All Company',
            active: true,
            icon: 'users',
            permission: PERMISSIONS.CUSTOMER.COMPANY.READ
          },
          {
            name: 'Company Representative',
            path: '/home/apps/representative',
            pathName: 'View All Representative',
            active: true,
            icon: 'user',
            permission: PERMISSIONS.CUSTOMER.REPRESENTATIVE.READ
          }
        ]
      },
      {
        name: 'Job Configuration',
        active: true,
        icon: 'tool',
        pages: [
          {
            name: 'job-types',
            path: '/home/apps/job-types/create-a-job-type',
            icon: 'box',
            active: true,
            permission: PERMISSIONS.JOB_CONFIGURATION.JOB_TYPE.READ
          },
          {
            name: 'job stage',
            active: true,
            icon: 'layers',
            path: '/home/apps/job-stage',
            pathName: 'create-job-stage',
            permission: PERMISSIONS.JOB_CONFIGURATION.JOB_STAGE.READ
          },
          {
            name: 'Rigs',
            active: true,
            icon: 'map',
            path: '/home/apps/rig',
            pathName: 'create-rig-location',
            permission: PERMISSIONS.JOB_CONFIGURATION.JOB_RIGS.READ
          },
          {
            name: 'Job Location',
            active: true,
            icon: 'map-pin',
            path: '/home/apps/location',
            pathName: 'create-job-location',
            permission: PERMISSIONS.JOB_CONFIGURATION.JOB_LOCATION.READ
          }
        ]
      },
      {
        name: 'Settings',
        active: true,
        icon: 'settings',
        path: '/home/apps/settings',
        pathName: 'View All Settings',
        pages: [
          {
            name: 'employee',
            active: true,
            icon: 'sliders',
            path: '/home/apps/employee',
            pathName: 'View All Employee',
            flat: true,
            permission: PERMISSIONS.EMPLOYEE.READ
          },
          {
            name: 'Roles',
            active: true,
            icon: 'user',
            path: '/home/apps/roles',
            pathName: 'View All Roles',
            flat: true,
            permission: PERMISSIONS.ROLES.READ
          }
        ]
      }
    ]
  }
];
